import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	externalLinkEmptySectionHeader: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'servicedesk-external-links.links.empty-link-section.external-link-emptty-section-header',
		defaultMessage: 'Link out to external resources from your help center',
		description: 'Header text for external link when no links are present',
	},
	externalLinkEmptyImageAlt: {
		id: 'servicedesk-external-links.links.empty-link-section.external-link-empty-image-alt',
		defaultMessage: 'empty help links image',
		description: 'Alt text for empty help links image',
	},
	externalLinkEmptySectionBody: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'servicedesk-external-links.links.empty-link-section.external-link-emptty-section-body',
		defaultMessage:
			'Give your customers and team access to external knowledge and tools from your Jira Service Management portal.',
		description: 'Body text for external link when no links are present',
	},
	externalLinkEmptySectionAddLinkButton: {
		id: 'servicedesk-external-links.links.empty-link-section.external-link-empty-section-add-link-button',
		defaultMessage: 'Add a link',
		description: 'Add a link button text for external link when no links are present',
	},
});
